"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _InfoLabel = _interopRequireDefault(require("../../../components/InfoLabel"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _CustomFields = _interopRequireDefault(require("./CustomFields"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var fields = ['firstName', 'lastName', 'username', 'passcode', 'field1', 'field2', 'field3', 'field4', 'field5', 'email', 'phone', 'role', 'group'];
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  var _super = _createSuper(Form);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.fields.role.onChange(_this.props.forCycle.roleHandle);
      _this.props.fields.group.onChange(_this.props.projectId);
    });
    return _this;
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props$fields = this.props.fields,
        firstName = _this$props$fields.firstName,
        lastName = _this$props$fields.lastName,
        username = _this$props$fields.username,
        passcode = _this$props$fields.passcode,
        field1 = _this$props$fields.field1,
        field2 = _this$props$fields.field2,
        field3 = _this$props$fields.field3,
        field4 = _this$props$fields.field4,
        field5 = _this$props$fields.field5,
        email = _this$props$fields.email,
        phone = _this$props$fields.phone;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        isEditing = _this$props.isEditing,
        submitting = _this$props.submitting;
      var individualPasscode = this.props.forCycle.settings.individualPasscode;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: firstName,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "First Name",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: lastName,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Last Name",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: username,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Username",
          tooltip: "A username will be generated if not provided",
          optional: true
        }),
        disabled: isEditing
      }), individualPasscode && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: passcode,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Passcode",
          tooltip: "A passcode will be auto-generated if not provided",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: email,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Email",
          tooltip: "If provided, the respondent will receive messaging here.",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: phone,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Phone",
          tooltip: "If provided, the respondent will receive messaging here.",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_CustomFields["default"], {
        customFields: [{
          field: field1,
          name: 'field_1'
        }, {
          field: field2,
          name: 'field_2'
        }, {
          field: field3,
          name: 'field_3'
        }, {
          field: field4,
          name: 'field_4'
        }, {
          field: field5,
          name: 'field_5'
        }]
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        isLoading: submitting,
        onClick: handleSubmit
      })));
    }
  }]);
  return Form;
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object,
  handleSubmit: _propTypes["default"].func,
  isEditing: _propTypes["default"].bool,
  submitting: _propTypes["default"].bool,
  forCycle: _propTypes["default"].object,
  projectId: _propTypes["default"].number
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    projectId: state.assignment.admin.currentProjectId
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({
  form: 'TestForm',
  fields: fields
})(Form));
exports["default"] = _default;